// ABOUTME: The grab affordance of a reorderable row — a 16px slot holding the six-dot grip
// ABOUTME: Grey at rest, blue while its row travels (docs/design/Рационы и библиотека.dc.html)

import type { Ref } from "react"
import { DragHandleIcon } from "@shared/icons"

interface CDragHandleProps {
  ref?: Ref<HTMLSpanElement>
  isDragging?: boolean
  /** What the handle does, for screen readers — the grip alone says nothing. */
  label: string
  className?: string
}

export const CDragHandle = ({ ref, isDragging = false, label, className = "" }: CDragHandleProps) => (
  <span
    ref={ref}
    aria-label={label}
    // The row underneath usually opens something; grabbing it must not.
    // Not a control: the stop keeps the click from reaching what lies behind it.
    role="presentation"
    onClick={(event) => event.stopPropagation()}
    className={`flex w-4 flex-none cursor-grab items-center justify-center active:cursor-grabbing ${isDragging ? "text-blue-600" : "text-gray-300"} ${className}`}
  >
    <DragHandleIcon color="currentColor" />
  </span>
)
